import "./nordic.ts";
import { recordSubmission } from "./submit.ts";

/**
 * Request-invitation form: required-field validation with live error-clearing
 * and focus-jump to the first problem. On success it records the submission to
 * the D1-backed endpoint (best-effort), stashes it in sessionStorage, and hands
 * off to /invitation-received, which personalises the confirmation.
 */
const form = document.getElementById("reqForm") as HTMLFormElement | null;
if (form) {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const byId = <T extends HTMLElement>(id: string) => document.getElementById(id) as T;
  const fieldOf = (el: Element): Element | null => el.closest(".field") ?? el.closest(".consent");
  const clearErr = (el: Element) => fieldOf(el)?.classList.remove("invalid");

  // Live: clear a field's error as soon as the user starts fixing it.
  for (const el of form.querySelectorAll<HTMLElement>("input,select,textarea")) {
    el.addEventListener("input", () => clearErr(el));
    el.addEventListener("change", () => clearErr(el));
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const problems: HTMLElement[] = [];
    const fail = (el: HTMLElement, wrap?: Element | null) => {
      (wrap ?? fieldOf(el))?.classList.add("invalid");
      problems.push(el);
    };

    const fname = byId<HTMLInputElement>("fname");
    const email = byId<HTMLInputElement>("email");
    const company = byId<HTMLInputElement>("company");
    const size = byId<HTMLSelectElement>("size");
    const consent = byId<HTMLInputElement>("consent");

    if (!fname.value.trim()) fail(fname);
    if (!emailRe.test(email.value.trim())) fail(email);
    if (!company.value.trim()) fail(company);
    if (!size.value) fail(size);
    if (!consent.checked) fail(consent, document.getElementById("consentWrap"));

    if (problems.length) {
      problems[0].focus({ preventScroll: false });
      return;
    }

    // Stash a friendly reference for the confirmation page, then hand off.
    const ref = `NIL-${Math.floor(100000 + Math.random() * 900000)}`;
    recordSubmission("invitation", {
      ref,
      name: fname.value.trim(),
      email: email.value.trim(),
      company: company.value.trim(),
      size: size.value,
      hp: form.querySelector<HTMLInputElement>('[name="hp"]')?.value ?? "",
    });
    try {
      sessionStorage.setItem(
        "nil_invite",
        JSON.stringify({
          ref,
          first: fname.value.trim().split(" ")[0],
          company: company.value.trim(),
          ts: Date.now(),
        }),
      );
    } catch {
      /* sessionStorage unavailable — proceed anyway; the page has a fallback */
    }

    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = ".7";
      submitBtn.textContent = "Sending…";
    }
    window.location.href = "/invitation-received";
  });
}
